import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { AutoUnsubscribe, Coerce, KalDialogConfig, KalDialogService } from '@kalidea/kaligraphi';
import { filter, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import {
    ConfirmDialogComponent,
    ConfirmDialogData
} from 'src/app/_shared/dialogs/confirm-dialog/confirm-dialog.component';

@Directive({
    selector: '[appConfirm]',
    standalone: false
})
export class ConfirmDirective implements OnDestroy {

    @Input() appConfirmTitle = '';

    @Input() appConfirmBody = 'Veuillez confirmer';

    @Input() appConfirmBodyTemplate: TemplateRef<any> = null;

    @Input() appConfirmParagraphs: string[];

    @Input() appConfirmSubmit = 'Oui';

    @Input() appConfirmCancel = 'Annuler';

    @Output('appConfirm') readonly confirm = new EventEmitter<void>();

    @Coerce('boolean')
    @Input() disabled = false;

    @AutoUnsubscribe()
    private subscription = Subscription.EMPTY;

    constructor(private kalDialogService: KalDialogService) {
    }

    @HostListener('click')
    confirmAction() {
        if (this.disabled) {
            return;
        }
        // open confirm dialog
        const dialogConfig = new KalDialogConfig<ConfirmDialogData>({
            title: this.appConfirmTitle,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-dark-backdrop',
            data: {
                body: this.appConfirmBody,
                paragraphs: this.appConfirmParagraphs,
                bodyTemplate: this.appConfirmBodyTemplate,
                cancelLabel: this.appConfirmCancel,
                submitLabel: this.appConfirmSubmit
            }
        });
        const dialogRef = this.kalDialogService.open(ConfirmDialogComponent, dialogConfig);

        // si l'utilisateur valide l'action
        this.subscription.unsubscribe();
        this.subscription = dialogRef.afterClosed
            .pipe(
                take(1),
                filter(result => !!result && result.accepted)
            )
            .subscribe(
                () => this.confirm.emit()
            );
    }

    ngOnDestroy(): void {
    }
}
